var map = {
	"./chat.png": 190,
	"./crossword.png": 683,
	"./demo.png": 1943,
	"./glossary.png": 9064,
	"./home.png": 4218,
	"./leaderboard.png": 4906,
	"./prototype.png": 2219,
	"./sequence.png": 5063,
	"./showcase.jpg": 5464,
	"./showcase2.jpg": 7993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9466;